import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";
import { IntlProvider } from "react-intl";

import LocalesContext from "./LocalesContext";
import { useUser } from "utils/hooks";

import enStrings from "translations/en.json";
import jaStrings from "translations/ja.json";
import zhStrings from "translations/zh.json";
// import xxStrings from "translations/xx.json";

const languages = {
  en: enStrings, // English
  ja: jaStrings, // Japanese
  zh: zhStrings, // Chinese
  // xx: xxStrings, // Debugging
};

function guessLocale() {
  const language = navigator?.languagess?.split("-")?.[0];

  if (languages[language]) {
    return language;
  }

  return "en";
}

function LocalesProvider({ children }) {
  const [storedLocale, setStoredLocale] = useState(() => localStorage.getItem("locale"));
  const { user } = useUser();
  const locale = storedLocale ?? user?.locale ?? guessLocale();
  const messages = languages[locale];

  const _setStoredLocale = useCallback(locale => {
    localStorage.setItem("locale", locale);
    setStoredLocale(locale);
  }, [setStoredLocale]);

  return (
    <LocalesContext.Provider value={{ locale, setLocale: _setStoredLocale }}>
      <IntlProvider locale={locale} messages={messages}>
        {children}
      </IntlProvider>
    </LocalesContext.Provider>
  );
};

LocalesProvider.defaultProps = {
};

LocalesProvider.propTypes = {
  children: PropTypes.any.isRequired,
};

export default LocalesProvider;
